export const volontariatoTranslations = {
  it: {
    kicker: "Volontariato",
    titleLines: ["Il tuo tempo può", "cambiare una vita."],
    sub: "Non servono superpoteri: servono mani, cuore e un po' di tempo. Unisciti ai volontari di You4Mada e aiutaci a costruire un futuro per i bambini del sud del Madagascar, dall'Italia o sul campo.",
    ctaPrimary: "Candidati ora",
    ctaSecondary: "Scopri come funziona",
    backHome: "Torna alla home",
    howLabel: "Come funziona",
    howTitle: "Tre passi per diventare volontario.",
    steps: [
      {
        n: "01",
        title: "Invia la candidatura",
        text: "Compila il modulo raccontandoci chi sei, cosa sai fare e quanto tempo puoi dedicarci.",
      },
      {
        n: "02",
        title: "Conosciamoci",
        text: "Ti ricontattiamo per una chiacchierata: capiamo insieme dove il tuo aiuto può fare la differenza.",
      },
      {
        n: "03",
        title: "Inizia a fare la differenza",
        text: "Entri nella squadra: dall'Italia, da remoto o direttamente in Madagascar. Anche se per te sembra poco, per noi vale tanto.",
      },
    ],
    areasLabel: "Come puoi aiutare",
    areasTitle: "C'è un posto per ognuno.",
    areas: [
      {
        key: "field",
        title: "Missioni sul campo",
        text: "Parti con noi in Madagascar per sostenere i progetti di istruzione, salute e nutrizione direttamente a Toliara.",
      },
      {
        key: "events",
        title: "Eventi e raccolta fondi",
        text: "Aiutaci a organizzare banchetti, mercatini, cene ed eventi di sensibilizzazione nella tua città.",
      },
      {
        key: "communication",
        title: "Comunicazione",
        text: "Social media, grafica, fotografia, traduzioni: racconta le nostre storie e amplifica la voce dei bambini.",
      },
      {
        key: "skills",
        title: "Competenze professionali",
        text: "Medici, insegnanti, artigiani, informatici: ogni professionalità può diventare un dono prezioso.",
      },
    ],
    formLabel: "Modulo di candidatura",
    formTitle: "Unisciti alla squadra.",
    formSub: "Compila il modulo: ti ricontatteremo entro pochi giorni per conoscerci meglio. Nessun impegno vincolante.",
    name: "Nome",
    surname: "Cognome",
    email: "Email",
    phone: "Telefono (opzionale)",
    areaLabel: "In quale area vorresti aiutare?",
    areaOptions: [
      { v: "field", label: "Missioni sul campo" },
      { v: "events", label: "Eventi e raccolta fondi" },
      { v: "communication", label: "Comunicazione" },
      { v: "skills", label: "Competenze professionali" },
      { v: "other", label: "Altro / Non so ancora" },
    ],
    availabilityLabel: "Quanto tempo puoi dedicare?",
    availabilityOptions: [
      { v: "occasional", label: "Occasionale" },
      { v: "weekly", label: "Qualche ora a settimana" },
      { v: "mission", label: "Disponibile per missioni" },
    ],
    message: "Raccontaci qualcosa di te: chi sei, cosa sai fare, perché vuoi aiutare…",
    submit: "Invia la candidatura",
    sending: "Invio in corso…",
    success: "Candidatura inviata! Ti ricontatteremo prestissimo. Grazie di cuore.",
    error: "Qualcosa è andato storto. Riprova.",
    note: "I tuoi dati saranno usati solo per ricontattarti. Per qualsiasi domanda scrivici a you4mada@gmail.com.",
    testimonials: [
      {
        quote: "Sono partita pensando di dare una mano. Sono tornata con molto più di quello che ho dato.",
        author: "Giulia, volontaria in missione",
      },
      {
        quote: "Anche da casa, con poche ore a settimana, sento di far parte di qualcosa di grande.",
        author: "Marco, volontario comunicazione",
      },
    ],
    faqLabel: "Domande frequenti",
    faqTitle: "Tutto quello che c'è da sapere.",
    faq: [
      {
        q: "Serve esperienza per diventare volontario?",
        a: "No. L'unica cosa indispensabile è la voglia di aiutare. Ti accompagniamo noi passo dopo passo, valorizzando quello che sai già fare.",
      },
      {
        q: "Posso fare volontariato senza partire per il Madagascar?",
        a: "Assolutamente sì. Gran parte dei nostri volontari opera dall'Italia: eventi, raccolta fondi, comunicazione, traduzioni e supporto organizzativo.",
      },
      {
        q: "Come funzionano le missioni sul campo?",
        a: "Organizziamo periodicamente missioni a Toliara. Dopo un percorso di preparazione insieme, definiamo durata, ruolo e attività in base alle esigenze dei progetti e alla tua disponibilità.",
      },
      {
        q: "Quanto tempo devo garantire?",
        a: "Non c'è un minimo: anche poche ore al mese sono preziose. Concordiamo insieme un impegno sostenibile per te.",
      },
      {
        q: "Il volontariato ha dei costi?",
        a: "Il volontariato in Italia è gratuito. Per le missioni sul campo, le spese di viaggio sono generalmente a carico del volontario: ti daremo tutte le informazioni durante il colloquio.",
      },
    ],
    galleryLabel: "I nostri volontari",
    galleryTitle: "Mani diverse, stesso cuore.",
  },
  en: {
    kicker: "Volunteering",
    titleLines: ["Your time can", "change a life."],
    sub: "No superpowers needed: just hands, heart and a bit of time. Join the You4Mada volunteers and help us build a future for the children of southern Madagascar, from home or in the field.",
    ctaPrimary: "Apply now",
    ctaSecondary: "See how it works",
    backHome: "Back to home",
    howLabel: "How it works",
    howTitle: "Three steps to become a volunteer.",
    steps: [
      {
        n: "01",
        title: "Send your application",
        text: "Fill in the form telling us who you are, what you can do and how much time you can give.",
      },
      {
        n: "02",
        title: "Let's meet",
        text: "We'll get back to you for a chat: together we'll find where your help can make the biggest difference.",
      },
      {
        n: "03",
        title: "Start making a difference",
        text: "Join the team: from home, remotely or directly in Madagascar. Even if it seems little to you, it means a lot to us.",
      },
    ],
    areasLabel: "How you can help",
    areasTitle: "There's a place for everyone.",
    areas: [
      {
        key: "field",
        title: "Field missions",
        text: "Travel with us to Madagascar to support education, health and nutrition projects directly in Toliara.",
      },
      {
        key: "events",
        title: "Events & fundraising",
        text: "Help us organise stalls, markets, dinners and awareness events in your city.",
      },
      {
        key: "communication",
        title: "Communication",
        text: "Social media, design, photography, translations: tell our stories and amplify the children's voices.",
      },
      {
        key: "skills",
        title: "Professional skills",
        text: "Doctors, teachers, craftspeople, IT specialists: every profession can become a precious gift.",
      },
    ],
    formLabel: "Application form",
    formTitle: "Join the team.",
    formSub: "Fill in the form: we'll get back to you within a few days to get to know each other. No binding commitment.",
    name: "First name",
    surname: "Last name",
    email: "Email",
    phone: "Phone (optional)",
    areaLabel: "Which area would you like to help in?",
    areaOptions: [
      { v: "field", label: "Field missions" },
      { v: "events", label: "Events & fundraising" },
      { v: "communication", label: "Communication" },
      { v: "skills", label: "Professional skills" },
      { v: "other", label: "Other / Not sure yet" },
    ],
    availabilityLabel: "How much time can you give?",
    availabilityOptions: [
      { v: "occasional", label: "Occasionally" },
      { v: "weekly", label: "A few hours a week" },
      { v: "mission", label: "Available for missions" },
    ],
    message: "Tell us about yourself: who you are, what you can do, why you want to help…",
    submit: "Send application",
    sending: "Sending…",
    success: "Application sent! We'll get back to you very soon. Thank you so much.",
    error: "Something went wrong. Please try again.",
    note: "Your data will only be used to contact you back. For any question write to you4mada@gmail.com.",
    testimonials: [
      {
        quote: "I left thinking I would lend a hand. I came back with far more than I gave.",
        author: "Giulia, mission volunteer",
      },
      {
        quote: "Even from home, with a few hours a week, I feel part of something big.",
        author: "Marco, communication volunteer",
      },
    ],
    faqLabel: "Frequently asked questions",
    faqTitle: "Everything you need to know.",
    faq: [
      {
        q: "Do I need experience to volunteer?",
        a: "No. The only essential thing is the will to help. We'll guide you step by step, building on what you already know how to do.",
      },
      {
        q: "Can I volunteer without travelling to Madagascar?",
        a: "Absolutely. Most of our volunteers work from Italy: events, fundraising, communication, translations and organisational support.",
      },
      {
        q: "How do field missions work?",
        a: "We periodically organise missions to Toliara. After a preparation path together, we define duration, role and activities based on project needs and your availability.",
      },
      {
        q: "How much time do I have to commit?",
        a: "There is no minimum: even a few hours a month are precious. We'll agree together on a commitment that is sustainable for you.",
      },
      {
        q: "Does volunteering have any costs?",
        a: "Volunteering in Italy is free. For field missions, travel expenses are generally covered by the volunteer: we'll give you all the details during the interview.",
      },
    ],
    galleryLabel: "Our volunteers",
    galleryTitle: "Different hands, same heart.",
  },
};
